import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn, Footer, IconSpinner, NamedLink } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import facebookImage from '../../assets/vivianlab-brandImage.png';
import twitterImage from '../../assets/vivianlab-brandImage.png';
import { withViewport } from '../../util/uiHelpers';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { useConfiguration } from '../../context/configurationContext';
import { isArrayLength, isLocaleGreek } from '../../util/genericHelpers';
import BlogCard from './BlogCard/BlogCard';
import SectionHero from './SectionHero';
import { parse } from '../../util/urlHelpers';
import Icons from '../../components/Icons/Icons';
import NoDataFound from '../../assets/no-data-found.jpg';
import css from './BlogPage.module.css';
import { getBlogPublishTimestamp } from '../../util/dataExtractors';
export const BlogPageComponent = props => {
  const {
    intl,
    scrollingDisabled,
    searchInProgress,
    blogsData,
    blogTags,
    location,
    history,
  } = props;
  const config = useConfiguration();
  const [scroll, setScroll] = useState(false);
  const siteTitle = config.marketplaceName;
  const schemaTitle = intl.formatMessage({ id: 'BlogPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({
    id: 'BlogPage.schemaDescription',
  });
  const [showMenu, setMenu] = useState(false);
  const tagsInSearch = location?.search && parse(location?.search);
  const selectedTags = tagsInSearch?.tags && tagsInSearch?.tags?.split(',');
  const schemaImage = `${config.marketplaceRootURL}${facebookImage}`;
  useEffect(() => {
    let isMounted = true;
    if (typeof window !== 'undefined') {
      const handleScroll = () => {
        if (isMounted) {
          setScroll(window.scrollY > 0);
        }
      };
      window.addEventListener('scroll', handleScroll);
      return () => {
        isMounted = false; // This is the cleanup for event listener
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);
  const isHeaderSticky = scroll ? css.sticky : '';
  const onFilterByTags = event => {
    const selectedTag = event.target.innerText;
    const urlParams = new URLSearchParams(location.search);
    const selectedTags = urlParams.getAll('tags');
    if (selectedTags.includes(selectedTag)) {
      // Remove the tag from the list if it's already selected
      const filteredTags = selectedTags.filter(tag => tag !== selectedTag);
      urlParams.delete('tags');
      if (isArrayLength(filteredTags)) {
        urlParams.append('tags', filteredTags.join(','));
      }
    } else {
      // Add the tag to the list if it's not already selected
      selectedTags.push(selectedTag);
      urlParams.set('tags', selectedTags.join(','));
    }
    history.push({ search: urlParams.toString() });
  };
  const onRemoveTag = tag => {
    const urlParams = new URLSearchParams(location.search);
    const tags = urlParams.get('tags');
    const tagArray = tags ? tags.split(',') : [];
    const updatedTags = tagArray.filter(t => t !== tag);
    if (updatedTags?.length === 0) {
      urlParams.delete('tags');
    } else {
      urlParams.set('tags', updatedTags.join(','));
    }
    history.push({ search: urlParams.toString() });
  };
  const renderTags = isArrayLength(blogTags)
    ? blogTags.map((tag, i) => (
        <li key={i} onClick={onFilterByTags}>
          {tag?.attributes?.name}
        </li>
      ))
    : null;
  const renderFiltersTags = isArrayLength(selectedTags) ? (
    <div className={css.filterSelected}>
      {selectedTags.map((tag, i) => (
        <span key={i} className={css.selectedTags} onClick={() => onRemoveTag(tag)}>
          {tag} <span className={css.clear}>&times;</span>
        </span>
      ))}
      <NamedLink className={css.clearAll} name="BlogPage">
        <FormattedMessage id="BlogPage.clearAll" />
      </NamedLink>
    </div>
  ) : null;
  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        {
          url: `${config.marketplaceRootURL}${twitterImage}`,
          width: 600,
          height: 314,
        },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn
        isStaticPage={true}
        className={css.pageRoot}
        topbar={<TopbarContainer isFullWidthHeader isPostLandingPage />}
        footer={<Footer />}
      >
        <div className={css.pageContent}>
          <SectionHero />
          <div className={css.blogsContainer}>
            <div className={css.blogsContent}>
              <div className={css.sideBar}>
                <h2>
                  <FormattedMessage id="BlogPage.blogCategories" />
                </h2>
                {renderFiltersTags}
                <ul>{renderTags}</ul>
              </div>
              {searchInProgress ? (
                <div className={css.loader}>
                  <IconSpinner />
                </div>
              ) : isArrayLength(blogsData) ? (
                <div className={css.mainBlogContent}>
                  <div className={css.mobileDrawerMenu}>
                    <div className={css.mobileDrawerMenuHead} onClick={() => setMenu(!showMenu)}>
                      <FormattedMessage id="BlogPage.blogCategories" />
                      <Icons name={showMenu ? 'upArrow' : 'downArrow'} />
                    </div>
                    {showMenu ? <ul className={css.accordionMenu}>{renderTags}</ul> : null}
                  </div>
                  {renderFiltersTags}
                  {isArrayLength(blogsData)
                    ? blogsData?.map((b, i) => <BlogCard key={i} blog={b} />)
                    : null}
                </div>
              ) : (
                <div className={css.noDataFound}>
                  <img src={NoDataFound} alt=" No Record Found" />
                  <h2>
                    <FormattedMessage id="BlogPage.noRecordFound" />
                  </h2>
                </div>
              )}
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};
const { bool, object } = PropTypes;
BlogPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};
const mapStateToProps = state => {
  const { searchInProgress, blogsData, blogTags, searchBlogsError } = state.BlogPage;
  const { currentUser } = state.user;

  // Ensure we have blogs array
  const blogsArray = isArrayLength(blogsData?.blogs) ? blogsData.blogs : [];

  const sortedArray = [...blogsArray].sort(
    (a, b) => getBlogPublishTimestamp(b) - getBlogPublishTimestamp(a)
  );

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    searchInProgress,
    blogTags,
    blogsData: sortedArray,
    searchBlogsError,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});
const BlogPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withViewport,
  injectIntl
)(BlogPageComponent);
export default BlogPage;
